import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayersThree"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.94678L22.668 8.00004L12 13.0533L1.33203 8.00004L12 2.94678ZM3.66801 8.00004L12 11.9468L20.332 8.00004L12 4.05329L3.66801 8.00004Z" fill="currentColor"/><Path d="M22.668 12L12 17.0533L1.33203 12L2.49982 11.4469L12 15.9468L21.4996 11.4466L22.668 12Z" fill="currentColor"/><Path d="M22.668 16L12 21.0533L1.33205 16L2.49984 15.4468L12 19.9467L21.4997 15.4466L22.668 16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersThree;
